/* Local calendar and editable size references: no storage or network. */
(function(root,factory){const api=factory();if(typeof module==='object'&&module.exports)module.exports=api;else root.IDCPdp=api;})(typeof globalThis!=='undefined'?globalThis:this,function(){
  function calendarDay(now,zone='America/Mexico_City') {
    try { const p=new Intl.DateTimeFormat('en-US',{timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now); const v=t=>Number(p.find(x=>x.type===t).value);return new Date(Date.UTC(v('year'),v('month')-1,v('day'),12)); } catch(_){return null;}
  }
  function businessDate(now,days,zone,exclusions='') {
    if(!Number.isInteger(days)||days<0||days>90)return null;
    const d=calendarDay(now,zone);if(!d)return null;
    const excluded=new Set(exclusions.split(/[\s,;]+/).filter(s=>/^\d{4}-\d{2}-\d{2}$/.test(s)));
    let left=days,guard=0;
    while(left>0&&guard++<500){d.setUTCDate(d.getUTCDate()+1);if(d.getUTCDay()!==0&&d.getUTCDay()!==6&&!excluded.has(d.toISOString().slice(0,10)))left--;}
    return left?null:d;
  }
  function deadline(value) {
    if(!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(String(value||'')))return null;
    const [year,month,day,hour,minute]=String(value).match(/\d+/g).map(Number);
    const calendar=new Date(Date.UTC(year,month-1,day));
    if(calendar.getUTCFullYear()!==year||calendar.getUTCMonth()!==month-1||calendar.getUTCDate()!==day||hour>23||minute>59)return null;
    const n=Date.parse(value);return Number.isFinite(n)?n:null;
  }
  function sizes(text) {
    return String(text||'').split('\n').map(line=>line.split('|').map(v=>v.trim())).filter(c=>c.length===7&&c[0]&&c.slice(1).every(n=>n!==''&&Number.isFinite(Number(n)))).map(c=>({size:c[0],length:+c[1],width:+c[2],hMin:+c[3],hMax:+c[4],wMin:+c[5],wMax:+c[6]})).filter(r=>r.length>0&&r.width>0&&r.hMin<=r.hMax&&r.wMin<=r.wMax);
  }
  function orderedSizes(rows) {
    const ordered=[...rows].sort((a,b)=>a.width-b.width||a.length-b.length);
    if(new Set(ordered.map(r=>r.size.toLowerCase())).size!==ordered.length)return [];
    // Do not treat neighbouring labels as interchangeable if the editable
    // chart is not a coherent progression of physical garment dimensions.
    return ordered.every((r,i)=>!i||r.length>=ordered[i-1].length&&r.width>ordered[i-1].width)?ordered:[];
  }
  function bracket(rows,value,key) {
    if(value<rows[0][key]||value>rows[rows.length-1][key])return [];
    const exact=rows.map((r,i)=>r[key]===value?i:-1).filter(i=>i>=0);
    if(exact.length)return exact;
    const upper=rows.findIndex(r=>r[key]>value);
    return upper>0?[upper-1,upper]:[];
  }
  function assess(rows,height,weight,garment={}) {
    const ordered=orderedSizes(rows),empty=(status,basis='body')=>({status,basis,options:[]});
    if(!ordered.length)return empty('guide');
    const hasWidth=garment.width!==undefined,hasLength=garment.length!==undefined;
    if(hasWidth||hasLength) {
      if(!hasWidth||!hasLength||!Number.isFinite(garment.width)||!Number.isFinite(garment.length)||garment.width<=0||garment.length<=0)return empty('invalid','garment');
      const width=bracket(ordered,garment.width,'width'),length=bracket(ordered,garment.length,'length');
      if(!width.length||!length.length)return empty('outside','garment');
      const indices=[...new Set([...width,...length])].sort((a,b)=>a-b);
      if(indices.length>2||indices[indices.length-1]-indices[0]>1)return empty('measure','garment');
      return {status:indices.length===1?'reference':'between',basis:'garment',options:indices.map(i=>ordered[i])};
    }
    if(!Number.isFinite(height)||!Number.isFinite(weight)||height<=0||weight<=0)return empty('invalid');
    const byHeight=ordered.map((r,i)=>height>=r.hMin&&height<=r.hMax?i:-1).filter(i=>i>=0);
    const byWeight=ordered.map((r,i)=>weight>=r.wMin&&weight<=r.wMax?i:-1).filter(i=>i>=0);
    if(!byHeight.length||!byWeight.length)return empty('outside');
    const matches=byHeight.filter(i=>byWeight.includes(i));
    if(matches.length) {
      if(matches.length>2||matches[matches.length-1]-matches[0]>1)return empty('measure');
      return {status:matches.length===1?'reference':'between',basis:'body',options:matches.map(i=>ordered[i])};
    }
    // An adjacent disagreement permits comparison, NOT a confirmed fit.
    // Larger disagreements need actual garment measurements; no BMI/chest
    // formula, invented tolerance, clamping or automatic leap to the max size.
    const pairs=byHeight.flatMap(h=>byWeight.map(w=>[h,w]));
    const gap=Math.min(...pairs.map(([h,w])=>Math.abs(h-w)));
    if(gap!==1)return empty('measure');
    const indices=[...new Set(pairs.filter(([h,w])=>Math.abs(h-w)===gap).flat())].sort((a,b)=>a-b);
    if(indices.length!==2)return empty('measure');
    return {status:'compare',basis:'body',options:indices.map(i=>ordered[i])};
  }
  function recommend(rows,height,weight) {return assess(rows,height,weight).options;}
  return {calendarDay,businessDate,deadline,sizes,recommend,assess};
});
